export default __webpack_public_path__ + "static/media/img-gnb-women-off.1bd2f3c7.svg";